import React from 'react'

import employees from '../../data/employees'
import Employee from '../../components/Employee'
import Heading from '../../components/Heading'
import List from '../../components/List'
import Phone from '../../components/Phone'
import { Grid, Col } from '../../components/Grid'
import Helmet from '../../components/seo/Helmet'

export default function Employees ({ helmetProps }) {
  const [tor, espen, ...rest] = employees
  const employeesRandomized = [tor, espen, ...rest.sort(() => 0.5 - Math.random())]

  return (
    <div>
      <Helmet {...helmetProps} />
      <h1>Folka</h1>

      {employeesRandomized.map(({ id, name, title, description, phone, email }) => (
        <Grid key={id} list>
          <Col>
            <Employee who={id} />
          </Col>
          <Col>
            <Heading small>{name}</Heading>

            <p>
              <em>{title}</em>
            </p>

            {(phone || email) && (
              <List>
                {phone && (
                  <li>
                    Telefon: <a href={`tel:${phone}`}><Phone>{phone}</Phone></a>
                  </li>
                )}
                {email && <li>Epost: <a href={`mailto:${email}`}>{email}</a></li>}
              </List>
            )}

            <div
              dangerouslySetInnerHTML={{ __html: description.props.children }}
            />
          </Col>
        </Grid>
      ))}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Employees/index.js